import { z } from 'zod';
import { DomainSchema, EmailSchema, IsoDateTimeSchema } from './common.js';
/** allowlist/{domain} — see docs/PLAN.md §2.2. The document id IS the normalized domain. */
export const AllowlistEntrySchema = z.object({
    domain: DomainSchema,
    note: z.string().max(500).optional(),
    disabled: z.boolean().default(false),
    addedByUid: z.string(),
    addedByEmail: EmailSchema.optional(),
    addedAt: IsoDateTimeSchema,
    source: z.enum(['ui', 'cli']).default('cli'),
});
export const AddAllowlistDomainInputSchema = z.object({
    domain: DomainSchema,
    note: z.string().max(500).optional(),
});
export const RemoveAllowlistDomainInputSchema = z.object({
    domain: DomainSchema,
    revokeSessions: z.boolean().default(false),
});
//# sourceMappingURL=allowlist.js.map